import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const unassignProductAccountEntitlementsSlice = getBulkActionSlice(
    'unassignProductAccountEntitlementsResult',
);

export const selectUnassignProductAccountEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.unassignProductAccountEntitlementsResult.shown;

export const selectUnassignProductAccountEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.unassignProductAccountEntitlementsResult.uuid;

export const selectUnassignProductAccountEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.unassignProductAccountEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = unassignProductAccountEntitlementsSlice.actions;
